import { Injectable } from "@angular/core";
import { Headers } from "@angular/http";
import { ServiceConfig } from "./service-config";
import { HttpClient } from "@angular/common/http";
@Injectable()
export class TiktokService {
  private host = ServiceConfig.host;
  private baseUrl = this.host + "/api/tiktok-management/";
  private data: any;
  headers: Headers;
  constructor(private http: HttpClient) {
    this.data = JSON.parse(localStorage.getItem("currentSmmData"));
    // console.log(this.data.token);
    this.headers = new Headers({
      "Content-Type": "application/json",
    });
  }

  //viettung goi api quan ly tai khoan uu tien ( thêm tk)
  public add(body: { url: string }) {
    let url = this.baseUrl + "addUser?token=" + this.data.token;
    return this.http.post<any>(url, body);
  }

  public getUsers(filter? : { sort: 1 | -1}) {
    let sort = -1
    if (filter && filter.sort) {
      sort = filter.sort
    }
    let url = this.baseUrl + `listUser?sort=${sort}&token=${this.data.token}`;
    return this.http.get<any>(url);
  }

  public deleteUser(body: {id: string}) {
    let url = this.baseUrl + "/deleteUser?token=" + this.data.token;
    return this.http.post<any>(url, body);
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_services/tiktok.service.ts